module.exports = __webpack_public_path__ + "static/sipora-logo-2c6cf95258732f81445d034f2b70d7e8.svg";